export const translations = {
  id: {
    nav: {
      about: "Tentang",
      timeline: "Linimasa",
      newFace: "Wajah Baru",
      contact: "Hubungi",
    },
    hero: {
      badge: "Era Baru Sedang Dimuat",
      manifest: "Manifes Migrasi",
      era: "Era Baru",
      line1: "Babak Baru",
      line2: "Logistik",
      line3: "Dimulai.",
      desc: "XPDC berpindah rumah. Domain baru, wajah baru, pengalaman baru. Kami sedang menyiapkan sesuatu yang akan mengubah cara Anda mengirim.",
      migrating: "Bermigrasi dari",
      to: "menuju",
      scroll: "Gulir untuk menjelajah",
    },
    countdown: {
      title: "Menuju Peluncuran",
      subtitle: "Hitung mundur menuju wajah baru XPDC",
      days: "Hari",
      hours: "Jam",
      minutes: "Menit",
      seconds: "Detik",
      launchOn: "Peluncuran pada",
    },
    manifesto: {
      title: "Mengapa Kami Berubah",
      subtitle: "Tiga alasan di balik transformasi XPDC",
      items: [
        {
          no: "01",
          title: "Wajah Baru",
          body: "Identitas visual yang lebih tajam, modern, dan berkelas. Sebuah ekosistem logistik yang siap membawa bisnis Anda melampaui batas.",
        },
        {
          no: "02",
          title: "Domain Baru",
          body: "Kami pindah ke rumah digital yang lebih kokoh dan tepercaya. Alamat baru, komitmen yang sama untuk keandalan pengiriman Anda.",
        },
        {
          no: "03",
          title: "Pengalaman Baru",
          body: "Antarmuka yang lebih cepat, cerdas, dan intuitif. Lacak resi, cek ongkir, dan kelola pengiriman dengan mulus di satu platform.",
        },
      ],
    },
    evolution: {
      label: "Evolusi",
      title: "Dari Lama ke Baru",
      subtitle: "Perbandingan wajah XPDC — kemarin dan hari ini.",
      oldLabel: "Tampilan Lama",
      newLabel: "Tampilan Baru",
      oldDomain: "Domain Sebelumnya",
      newDomain: "Domain Baru",
    },
    launched: {
      badge: "Resmi Meluncur",
      title: "Kami Sudah Live!",
      desc: "Wajah baru XPDC telah hadir. Rasakan ekosistem logistik generasi terbaru sekarang juga.",
      cta: "Kunjungi",
      celebrate: "Selamat datang di babak baru",
    },
    footer: {
      rights: "Seluruh hak cipta dilindungi.",
      company: "PT Xentra Platform Digital Cargo",
      tagline: "Logistics Game Changer",
    },
  },
  en: {
    nav: {
      about: "About",
      timeline: "Timeline",
      newFace: "New Face",
      contact: "Contact",
    },
    hero: {
      badge: "A New Era Is Loading",
      manifest: "Migration Manifest",
      era: "New Era",
      line1: "A New Chapter",
      line2: "In Logistics",
      line3: "Begins.",
      desc: "XPDC is moving home. New domain, new face, new experience. We're crafting something that will redefine the way you ship.",
      migrating: "Migrating from",
      to: "to",
      scroll: "Scroll to explore",
    },
    countdown: {
      title: "Until Launch",
      subtitle: "Counting down to the new face of XPDC",
      days: "Days",
      hours: "Hours",
      minutes: "Minutes",
      seconds: "Seconds",
      launchOn: "Launching on",
    },
    manifesto: {
      title: "Why We're Changing",
      subtitle: "Three reasons behind the XPDC transformation",
      items: [
        {
          no: "01",
          title: "A New Face",
          body: "A sharper, more modern and premium visual identity. A logistics ecosystem built to carry your business beyond limits.",
        },
        {
          no: "02",
          title: "A New Domain",
          body: "We're moving to a stronger, more trusted digital home. A new address, the same commitment to reliable delivery.",
        },
        {
          no: "03",
          title: "A New Experience",
          body: "A faster, smarter, more intuitive interface. Track shipments, check rates, and manage deliveries seamlessly in one platform.",
        },
      ],
    },
    evolution: {
      label: "Evolution",
      title: "From Old to New",
      subtitle: "The XPDC face — yesterday and today.",
      oldLabel: "Previous Look",
      newLabel: "New Look",
      oldDomain: "Previous Domain",
      newDomain: "New Domain",
    },
    launched: {
      badge: "Officially Launched",
      title: "We're Live!",
      desc: "The new face of XPDC has arrived. Experience the next generation logistics ecosystem right now.",
      cta: "Visit",
      celebrate: "Welcome to a new chapter",
    },
    footer: {
      rights: "All rights reserved.",
      company: "PT Xentra Platform Digital Cargo",
      tagline: "Logistics Game Changer",
    },
  },
};
